<template>
      <div>
            <v-alert dense v-if="error" color="red" elevation="5" outlined text type="error" align="center" class="mr-1 ml-1">
                  {{ alertValidate }}</v-alert>
      </div>
</template>

<script>
export default {
      props: {
            error: Boolean,
            alertValidate: String
      }
}

</script>